import React, { FC, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

import { Chip } from './chip';
import Button from 'core/react/general/form/Button';
import { getParsedSearchParams } from 'helpers/getParsedSearchParams';
import { FILTERS_ATTRIBUTES, FILTERS_GROUPS, FiltersGroups } from 'constants/filters';

import styles from './styles.module.css';

interface IFiltersChipsProps {
  filtersGroup: FiltersGroups;
}

export const FiltersChips: FC<IFiltersChipsProps> = ({ filtersGroup }) => {
  const { replace } = useHistory();
  const { pathname, search } = useLocation();

  const searchParams = qs.parse(search, { ignoreQueryPrefix: true, duplicates: 'combine' });

  const navigationPayload = getParsedSearchParams(searchParams);

  const selectedFilters = useMemo(() => {
    const filters: any = [];

    navigationPayload.forEach(([key, value]) => {
      const filterAttributes = FILTERS_ATTRIBUTES[filtersGroup][key];

      if (filterAttributes) {
        const { label, valueType } = filterAttributes;

        return filters.push({ urlKey: key, label, value: value, valueType });
      }
    });

    return filters;
  }, [searchParams]);

  const removeFilter = (name: string, value: string) => () => {
    const filteredParams = navigationPayload.filter((param) => !(param.includes(name) && param.includes(value)));

    const params = new URLSearchParams(filteredParams);

    params.set('page', '1');

    replace(`${pathname}?${params.toString()}`);
  };

  const removeAllFilters = () => {
    const params = new URLSearchParams(navigationPayload);

    params.set('page', '1');

    FILTERS_GROUPS[filtersGroup].forEach((filter) => params.delete(filter.urlKey));

    replace(`${pathname}?${params.toString()}`);
  };

  return selectedFilters?.length ? (
    <div className={styles.container}>
      <div className={styles.chips}>
        {/*@ts-ignore*/}
        {selectedFilters?.map((filter, index) => (
          <Chip key={index} removeFilter={removeFilter} {...filter} />
        ))}
      </div>
      {/*<Button title="clear all filters" onClick={removeAllFilters} />*/}
    </div>
  ) : null;
};
